import styled from "styled-components";

export const ExcentButton = styled.button`
  background-color: ${(props) => (props.checked ? "#595959" : "#FFFFFF")};
  border-radius: 5px;
  padding: 8px 10px;
  color: ${(props) => (props.checked ? "#FFFFFF" : "#595959")};
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 5px;
  border: 1px solid #a6a6a6;
  &:hover {
    border: ${(props) => !props.checked && "1px solid #a6a6a6"};
    background-color: ${(props) => !props.checked && "#f2f2f2"};
  }
`;

export const ExcentIncrementButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 100%;
  border: 2px solid #1a1a1a;
  font-size: 18px;
  &:hover {
    background-color: #1a1a1a;
    color: #fff;
  }
  transition: all 200ms ease;
`;

export const ExcentSubmitButton1 = styled.button`
  width: ${(props) => `${props.width}px`};
  border-radius: 25px;
  padding: 10px;
  border: 2px solid #262626;
  color: #262626;
  font-size: 18px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  column-gap: 10px;
  &:hover {
    background-color: #1a1a1a;
    color: #fff;
    border: 2px solid transparent;
  }
`;

export const ExcentSubmitButton2 = styled.button`
  min-width: 300px;
  border-radius: 25px;
  padding: 10px;
  border: 2px solid #1a1a1a;
  background-color: #262626;
  color: #fff;
  font-size: 18px;
  border: 2px solid transparent;
  &:hover {
    background-color: #404040;
    color: #fff;
  }
`;
